<div class="security-container" id="holding-container">
  <div class="column-0">
    <div class="settings-section">
      <label class="section-label">{{
        'auth.securitySettings.changePassword' | translate
      }}</label>
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          [label]="'auth.securitySettings.currentPassword' | translate"
          formName="oldPassword"
          [value]="oldPassword"
          mandatory="true"
          (validationError)="onErrorHandler($event, 'oldPassword')"
          (changed)="onInputChange($event, 'oldPassword')"
          type="password"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'auth.securitySettings.newPassword' | translate"
          formName="newPassword"
          [value]="newPassword"
          mandatory="true"
          [noteText]="'auth.securitySettings.minimumCharacters' | translate"
          (validationError)="onErrorHandler($event, 'newPassword')"
          (changed)="onInputChange($event, 'newPassword')"
          type="password"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'auth.securitySettings.confirmNewPassword' | translate"
          formName="confirmedPassword"
          [value]="confirmedPassword"
          [noteText]="'auth.securitySettings.minimumCharacters' | translate"
          mandatory="true"
          (validationError)="onErrorHandler($event, 'confirmedPassword')"
          (changed)="onInputChange($event, 'confirmedPassword')"
          type="password"
        ></ops-input>

        <div class="password-missmatch" *ngIf="passwordMissmatch">
          {{ 'auth.securitySettings.passwordMismatch' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
